// extracted by mini-css-extract-plugin
export default {"host":"MainMenu_host__TBLaa","host_collapsed":"MainMenu_host_collapsed__Y8oi3","coccyx":"MainMenu_coccyx__ko2b6","spring":"MainMenu_spring__tXn3K"};